export const getTelephoneBackDigits = (telephoneNumber: string) => {
  if (telephoneNumber.length < 4) return telephoneNumber;
  else return telephoneNumber.substring(telephoneNumber.length - 4)
}